/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    Datagrid,
    TextField,
    Show,
    Create,
    BooleanField,
    NumberField,
    SimpleForm,
    ReferenceField,
    Edit,
    SimpleShowLayout,
    ReferenceInput,
} from 'react-admin';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import { AutocompleteInput, BooleanInput, NumberInput, TextInput } from '../lib/wrappers/Inputs';

export const FacultySubGroupLabels = {
    pageTitle: 'Subjects',
    singleLabel: 'Subject',
    Title: 'Code',
    facultygroup_id: 'Faculty Group',
    faculty: 'Faculty',
};

export const FacultySubGroupList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList {...props} filters={<BaseFilter />}>
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField source="description" />
                    <TextField label="Code" source="Title" />
                    <ReferenceField
                        label={FacultySubGroupLabels.facultygroup_id}
                        reference="FacultyGroup"
                        source="facultygroup_id"
                        allowEmpty
                    >
                        <TextField source="Title" />
                    </ReferenceField>
                    <ReferenceField
                        label={FacultySubGroupLabels.faculty}
                        reference="FacultyGroup"
                        source="facultygroup_id"
                    >
                        <ReferenceField
                            reference="Faculty"
                            source="faculty_id"
                            linkType="show"
                        >
                            <TextField source="Title" />
                        </ReferenceField>
                    </ReferenceField>
                    <BooleanField source="current" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const FacultySubGroupEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
                <SimpleForm  toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput
                        label={FacultySubGroupLabels.Title}
                        source="Title"
                    />
                    <TextInput source="description" />
                    <BooleanInput source="current" />
                    <NumberInput source="type_id" />
                    <ReferenceInput
                        label={FacultySubGroupLabels.facultygroup_id}
                        reference="FacultyGroup"
                        source="facultygroup_id"
                    >
                        <AutocompleteInput optionText="description" />
                    </ReferenceInput>
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const FacultySubGroupCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput label={FacultySubGroupLabels.Title} source="Title" />
            <TextInput source="description" />
            <BooleanInput source="current" defaultValue={false} />
            <NumberInput
                label={FacultySubGroupLabels.type_id}
                source="type_id"
            />
            <ReferenceInput
                label={FacultySubGroupLabels.facultygroup_id}
                reference="FacultyGroup"
                source="facultygroup_id"
            >
                <AutocompleteInput optionText="Title" />
            </ReferenceInput>
        </SimpleForm>
    </Create>
);

export const FacultySubGroupShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label={FacultySubGroupLabels.Title} source="Title" />
            <TextField source="description" />
            <BooleanField source="current" />
            <NumberField
                label={FacultySubGroupLabels.type_id}
                source="type_id"
            />
            <ReferenceField
                label={FacultySubGroupLabels.facultygroup_id}
                reference="FacultyGroup"
                source="facultygroup_id"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <TextField source="created_at" />
            <TextField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
